import React, { useState } from 'react';
import { apiUrl } from '../api';
import { AlertTriangle, Send } from 'lucide-react';
import { motion } from 'motion/react';

export const EmergencyBroadcastWidget = () => {
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState('');

  const handleBroadcast = async () => {
    if (!message) return;
    setIsSending(true);
    try {
      await fetch(apiUrl('/api/broadcast'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message })
      });
      alert('Emergency Broadcast Sent!');
      setMessage('');
    } catch (e) {
      console.error(e);
      alert('Failed to send broadcast');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-[32px] shadow-sm border border-red-200">
      <h3 className="text-sm font-black text-red-600 flex items-center gap-2 mb-4">
        <AlertTriangle className="w-5 h-5" /> Emergency Broadcast
      </h3>
      <textarea
        className="w-full p-4 bg-red-50 border border-red-100 rounded-2xl mb-4 text-sm font-medium"
        placeholder="Enter critical safety alert..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <button
        onClick={handleBroadcast}
        disabled={isSending || !message}
        className="w-full py-3 bg-red-600 text-white rounded-xl font-black text-sm hover:bg-red-700 transition flex items-center justify-center gap-2"
      >
        {isSending ? 'Sending...' : 'Broadcast to Team'} <Send className="w-4 h-4" />
      </button>
    </div>
  );
};
